const _ = require('lodash')
const v = require('valentine')
const { format: dateFormat } = require('shared/date')
const jsonUtils = require('shared/json-utils')
const ApplicationController = require('client/controllers/application-controller')
const uploader = require('client/lib/uploader')
const userList = require('*views/admin/user-list')
const adminUsersListItems = require('*views/admin/admin-users-list-items')
const reservedUsernameList = require('*views/admin/reserved-username-list')
const userListHeader = require('*views/admin/user-list-header')
const reservedUsernameListHeader = require('*views/admin/reserved-username-list-header')
const inviteRows = require('*views/admin/invite-row')
const topicList = require('*views/admin/topic-list')
const urlList = require('*views/admin/url-list')

const VALID_PERCENTAGE_REGEX = /^\d{1,3}\.?\d{0,3}$/
const $doc = $(document)

const ROLLOUT_FORM_SELECTOR = '.rollout-modifier__form'
const ROLLOUT_INPUT_SELECTOR = '.rollout-modifier__input'
const ROLLOUT_INPUT_MIN_SELECTOR = '.rollout-modifier__input--min'
const ROLLOUT_INPUT_MAX_SELECTOR = '.rollout-modifier__input--max'
const ROLLOUT_SUBMIT_SELECTOR = '.rollout-modifier__submit'

let usersPage = 0

module.exports = class AdminController extends ApplicationController {
  rollout() {
    $doc.on('input', ROLLOUT_INPUT_SELECTOR, event => {
      const $target = $(event.currentTarget)
      const $form = $target.closest(ROLLOUT_FORM_SELECTOR)
      const $submit = $form.find(ROLLOUT_SUBMIT_SELECTOR)
      const $minInput = $form.find(ROLLOUT_INPUT_MIN_SELECTOR)
      const $maxInput = $form.find(ROLLOUT_INPUT_MAX_SELECTOR)
      $form.removeClass('has-success')
      $submit.prop('disabled', !isValidPercentageRange($minInput, $maxInput))
    })
    $doc.on('submit', ROLLOUT_FORM_SELECTOR, event => {
      event.preventDefault()
      const $form = $(event.currentTarget)
      const $submit = $form.find(ROLLOUT_SUBMIT_SELECTOR)
      const $minInput = $form.find(ROLLOUT_INPUT_MIN_SELECTOR)
      const $maxInput = $form.find(ROLLOUT_INPUT_MAX_SELECTOR)
      if (isValidPercentageRange($minInput, $maxInput)) {
        const handlerName = $form.attr('data-handler')
        const modifierName = $form.attr('data-modifier')
        const minValue = $minInput.val()
        const maxValue = $maxInput.val()
        const url = '/api/admin/rollouts/' + handlerName
        const data = {
          [modifierName]: { min: minValue, max: maxValue }
        }
        this.ajax({ url, method: 'put', data })
        .then(function () {
          $form.addClass('has-success')
          $minInput.prop('defaultValue', minValue)
          $maxInput.prop('defaultValue', maxValue)
          $submit.attr('disabled', true)
        })
        .catch(() => window.alert('Error updating rollout'))
      }
    })
  }

  show() {
    $('.userautocomplete').userautocomplete()
    var self = this
    self.ajax({
      url: '/api/admin/users/recent/' + (++usersPage),
      method: 'post'
    })
    .then(function (response) {
      if (!response.users || !response.users.length) {
        return
      }
      v(response.users).each(function (u) {
        u['created_at'] = dateFormat('m/d/Y g:ia', new Date(Date.parse(u['created_at'])))
      })
      $('#user-actions-navbar').empty()
      $('#user-actions-navbar').append(userListHeader({
          dataUrl: '/api/admin/users/recent/',
          page: 1,
          filter: 'all'
        })
      )
      jQuery('.dropdown-button').dropdown({
        'beloworigin': true,
        'constrain_width': false,
        'alignment': 'right'
      })
      $('#user-results').append(userList({
        users: response.users,
        userCategories: wiggin.userCategories,
        userTypes: wiggin.userTypes
      }))
    })
    .catch(() => window.alert('Error getting users'))

    self.ajax({
      url: '/api/admin/users/admin-role-access',
      method: 'get'
    })
    .then(function (response) {
      jQuery('.collapsible').collapsible({
        accordion: true
      })

      $('#admin-users-list-results').append(adminUsersListItems({
        adminUsers: response.usersWithAdminAccess,
        userCategories: wiggin.userCategories,
        userTypes: wiggin.userTypes
      }))
    })
    .catch(() => window.alert('Error getting roles'))

    self.ajax({
      url: '/api/admin/reserved-usernames/1',
      method: 'get'
    })
    .then(function (response) {
      if (!response.reservedUsernames || !response.reservedUsernames) {
        return
      }
      v(response.reservedUsernames).each(function (u) {
        u['created_at'] = dateFormat('m/d/Y g:ia', new Date(Date.parse(u['created_at'])))
      })
      $('#reserved-username-actions-navbar').empty()
      $('#reserved-username-actions-navbar').append(reservedUsernameListHeader({
          dataUrl: '/api/admin/reserved-usernames/',
          page: 1,
          filter: 'all'
        })
      )

      $('#reserved-username-list').append(reservedUsernameList({ reservedUsernames: response.reservedUsernames }))
    })
    .catch(() => window.alert('Error getting reserved usernames'))

    $('form#user-search').on('submit', function (e) {
      e.preventDefault()
      var searchTerm = $('#username-search').val().trim()
      if (!searchTerm) {
        return false
      }

      $('#user-results').empty()
      self.ajax({
        url: '/api/admin/users/search/'+ searchTerm,
        method: 'post'
      })
      .then(function (response) {
        v(response.users).each(function (u) {
          u['created_at'] = dateFormat('m/d/Y g:ia', new Date(Date.parse(u['created_at'])))
        })
        $('#user-results').append(userList({
          users: response.users,
          userCategories: wiggin.userCategories,
          userTypes: wiggin.userTypes
        }))
      })
      .catch(() => window.alert('Error searching for users'))
    })

    $('form#bulk-upload-reserved-usernames').on('submit', function (e) {
      e.preventDefault()

      var reservedUsernamesFile = $('#reserved-usernames-file')[0].files[0]

      if (!reservedUsernamesFile || 'text/csv' !== reservedUsernamesFile.type) {
        window.alert('Please provide a csv file.')
      } else if (reservedUsernamesFile.size > 1048576) {
        window.alert('File size cannot exceed 1MB')
      } else {
        uploader('/api/admin/reserved-usernames/bulk-upload',
        'reservedUsernamesFile', reservedUsernamesFile)
        .then(jsonUtils.parseHijackProofJSON)
        .then(function (response) {
          window.alert('Successes: ' + response.results.successes + '\n' +
            'Failures: ' + response.results.failures)
        })
        .catch(() => window.alert('Error uploading reserved usernames'))
      }
    })

    $('form#bulk-upload-user-categories').on('submit', _.throttle(function (e) {
      e.preventDefault()
      let userCategoriesFile = $('#user-categories-file')[0].files[0]

      if (!userCategoriesFile || 'text/csv' !== userCategoriesFile.type) {
        window.alert('Please provide a csv file.')
      } else if (userCategoriesFile.size > 1048576) {
        window.alert('File size cannot exceed 1MB')
      } else {
        uploader('/api/admin/user-categories/bulk-upload',
          'userCategoriesFile', userCategoriesFile)
          .then(jsonUtils.parseHijackProofJSON)
          .then(response => {
            if (response == 'OK') {
              window.alert('User category update successful.')
              window.location.href = '/admin'
            } else {
              window.alert('User category update failed.')
            }
          })
          .catch(function (error) {
            window.alert(error)
          })
      }
    }, 100))

    $('form#topic-search').on('submit', function (e) {
      e.preventDefault()
      $('#topic-results').empty()
      self.ajax({
        url: '/api/v0.1/interests/search',
        method: 'post',
        data: { text: $('#topic-text-search').val() }
      })
      .then(function (response) {
        v(response.items).each(function (t) {
          t['created_at'] = dateFormat('m/d/Y g:ia', new Date(Date.parse(t['created_at'])))
        })
        $('#topic-results').append(topicList({ topics: response.items }))
      })
      .catch(() => window.alert('Error searching for users'))
    })

    $('form#url-search').on('submit', function (e) {
      e.preventDefault()
      $('#url-results').empty()
      self.ajax({
        url: '/api/admin/urls/search',
        method: 'post',
        data: {
          text: $('#url-text-search').val()
        }
      })
      .then(function (response) {
        v(response.urls).each(function (c) {
          c['created_at'] = dateFormat('m/d/Y g:ia', new Date(Date.parse(c['created_at'])))
        })
        $('#url-results').append(urlList({ urlsIngested: response.urlsIngested }))
      })
      .catch(() => window.alert('Error searching for urls'))
    })

    $doc.on('click', 'td.verified-column', function (ev) {
      ev.preventDefault()
      var $this = $(this)
      var userId = $this.closest('tr').attr('data-user-id')
      var verified = $this.attr('data-verified') == 'true' ? false : true
      var text = verified ? '✓' : '✗'
      self.ajax({
        url: '/api/admin/users/' + userId,
        method: 'put',
        data: {
          properties: {
            verified: verified
          }
        }
      })
      .then(function () {
        $this.text(text)
      })
      .catch(() => window.alert('Error getting user'))
    })

    $doc.on('click', '.remove-user', function (ev) {
      ev.preventDefault()
      if (!window.confirm('Are you sure?')) {
        return
      }
      self.ajax({
        url: '/api/admin/users/' + $(this).attr('data-user-id'),
        method: 'delete'
      })
      .then(function () {
        $(ev.target).closest('tr').remove()
      })
      .catch(() => window.alert('Error deactivating user'))
    })

    $doc.on('click', '.remove-reserved-username', function (ev) {
      ev.preventDefault()
      if (!window.confirm('Are you sure?')) {
        return
      }
      self.ajax({
        url: '/api/admin/reserved-usernames/' + $(this).attr('data-reserved-username'),
        method: 'delete'
      })
      .then(function () {
        $(ev.target).closest('tr').remove()
      })
      .catch(() => window.alert('Error deleting reserved username'))
    })

    self.ajax({
      url: '/api/admin/get-invite-queue',
      success: function (response) {
        $(inviteRows({ invitees: response })).appendTo('.recent-invites table tbody.invite-queue-list')
      }
    })

    var pathMatch = window.location.pathname.match(/^\/admin\/manage-(.+)/i)
    var tabPaths = [
      'users',
      'reserved-usernames',
      'user-categories',
      'send-invites',
      'reporting',
      'caching',
      'topics',
      'urls',
      'stats'
    ]
    if ((pathMatch !== null) && tabPaths.indexOf(pathMatch[1]) > -1) {
      enableTab(pathMatch[1])
    } else {
      $('#users').show('block')
    }

  }
}

function enableTab(tab) {
  $('.additional-nav-links').children().each(function () {
    $(this).hide()
  })

  $('.primary-nav-links').children().each(function () {
    $(this).hide()
  })

  $('#' + tab).show('block')
  $('a[href="#' + tab + '"]').addClass('active')
}

function isValidPercentageRange($minInput, $maxInput) {
  const minValue = $minInput.val()
  const maxValue = $maxInput.val()
  const minDefault = $minInput.prop('defaultValue')
  const maxDefault = $maxInput.prop('defaultValue')
  return (
    (minValue != minDefault || maxValue != maxDefault) &&
    VALID_PERCENTAGE_REGEX.test(minValue) &&
    VALID_PERCENTAGE_REGEX.test(maxValue) &&
    (maxValue == 0 || maxValue > minValue)
  )
}
